import { render, staticRenderFns } from "./matching-card-thumbnail.vue?vue&type=template&id=61be41f4&scoped=true&"
import script from "./matching-card-thumbnail.vue?vue&type=script&lang=ts&"
export * from "./matching-card-thumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-thumbnail.vue?vue&type=style&index=0&id=61be41f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be41f4",
  null
  
)

export default component.exports